/* lua.js generated code undefined */

let Base = unpack(require("clover/logic/userTagData/UserTagBase"))[0]
let Tag = xClass("ActiveLevelTag", Base)
Tag.prototype.init = function () {
    let self = this
    self.activeDay = table()
    self.config = table()
    UserLevel.getInstance().on(UserLevelEvent.StartLevel, handler(self, self.logStartLevel))
}
Tag.prototype.logStartLevel = function (event) {
    let self = this
    let now = Localhost.timeInDay()
    if (!table.indexof(self.activeDay, now)) {
        table.insert(self.activeDay, now)
        table.sort(self.activeDay)
        while ($len(self.activeDay) > 30) {
            table.remove(self.activeDay, 1)
        }
        self.needStoreData()
    }
}
Tag.prototype.convertOnlineRecord = function (data) {
    let self = this
    return table([1, "activeDay", data.levelActives])
}
Tag.prototype.refresh = function (data) {
    let self = this
    self.activeDay = table()
    if (data.activeDay) {
        self.activeDay = table()
        for (let i = 1, v = data.activeDay[1]; v; i++, v = data.activeDay[i]) {
            table.insert(self.activeDay, tonumber(v))
        }
    }
    if (data.config) {
        self.config = table()
        for (let k in data.config) {
            let v = data.config[k]
            if ($null(v)) continue
            self.config[tonumber(k) || 0] = table([1, "min", tonumber(v.min) || 0], [1, "max", tonumber(v.max) || 0])
        }
    }
}
function getDayStartTimeByTS(ts) {
    let utc8TimeOffset = 57600
    let oneDaySeconds = 86400
    return ts - ((ts - utc8TimeOffset) % oneDaySeconds)
}
Tag.prototype.getTag = function () {
    let self = this
    let createTime = UserManager.getInstance().createTime
    let now = Localhost.time()
    if (now / 1000 - getDayStartTimeByTS(createTime / 1000) <= 14 * 86400) {
        return 1
    } else {
        // var
        let now = Localhost.timeInDay()
        if ($len(self.activeDay) === 0) {
            return 0
        }
        // 2.如果当前时间，小于记录里的最大值，那么认为调时间，返回0
        table.sort(self.activeDay)
        if (now < self.activeDay[$len(self.activeDay)]) {
            return 0
        }
        let count = 0
        for (let i = 1, v = self.activeDay[1]; v; i++, v = self.activeDay[i]) {
            if (v >= now - 14 && v < now) {
                count = count + 1
            }
        }
        for (let k in self.config) {
            let v = self.config[k]
            if ($null(v)) continue
            if (count >= v.min && count < v.max) {
                // 3.用打点上传数据，作为查询bug的依据
                if (k === 5 && DCAssist && DCAssist.dcForActiveLevelBug) {
                    DCAssist.dcForActiveLevelBug(now, self.activeDay[1], self.activeDay[$len(self.activeDay)])
                }
                return k
            }
        }
    }
    return 0
}
Tag.prototype.encode = function () {
    let self = this
    // 4.改为联网才可以上传数据，否则返回0
    let data = table()
    data.activeDay = table()
    data.config = self.config
    return data
}
module.exports = Tag
